import React from "react";
import AiAssessmentCodeAnswerBlock from "./AiAssessmentCodeAnswerBlock";
import AiAssessmentCodingRound from "./AiAssessmentCodingRound";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import "./aiAssessmentCodingScreen.scss";

interface AiAssessmentCodingScreenProps {
  handleCodingFullscreenToggle: () => void;
  isCodingFullscreen: boolean;
}

const AiAssessmentCodingScreen: React.FC<AiAssessmentCodingScreenProps> = ({
  handleCodingFullscreenToggle,
  isCodingFullscreen,
}) => {
  const { currentStep, aiAssessmentQuestions, isRoundFinished } =
    useAIAssessmentContext();
  const question = aiAssessmentQuestions[currentStep];
  const userAnswer = question.answer;
  const isCompleted = isRoundFinished || question.answer !== null;

  const getCodingScreenContent = () => {
    if (isCompleted) {
      return <AiAssessmentCodeAnswerBlock userAnswer={userAnswer} />;
    } else {
      return (
        <AiAssessmentCodingRound
          handleCodingFullscreenToggle={handleCodingFullscreenToggle}
          isCodingFullscreen={isCodingFullscreen}
        />
      );
    }
  };
  return (
    <div className="ai-assessment-coding-screen-container">
      {getCodingScreenContent()}
    </div>
  );
};

export default AiAssessmentCodingScreen;
